import ctl from '@netlify/classnames-template-literals'
import { useAtom } from 'jotai'
import { motion } from 'motion/react'
import { useTranslation } from 'react-i18next'
import { AnimateChangeInHeight, TextField } from '../rapid-ui'
import { landingPageMetaReachOverrideEnabledAtom, landingPageMetaReachOverrideUrlAtom } from './state'

export function ReachOverrideEditor() {
	const { t } = useTranslation('editor')
	const [customUrl, setCustomUrl] = useAtom(landingPageMetaReachOverrideUrlAtom)
	const [customUrlEnabled, setCustomUrlEnabled] = useAtom(landingPageMetaReachOverrideEnabledAtom)

	return (
		<div className="relative">
			<motion.div
				layout
				animate={{
					width: '450px',
					padding: customUrlEnabled ? '20px' : '0px',
					marginTop: customUrlEnabled ? '0px' : '20px',
					backgroundColor: customUrlEnabled ? 'rgba(255, 255, 255, 1)' : 'rgba(255, 255, 255, 0)',
				}}
				className="bg-white rounded-lg flex flex-col items-center"
				transition={{
					width: {
						type: 'spring',
						bounce: 0.33,
						duration: 0.35,
					},
				}}
			>
				<motion.button
					animate={{
						color: customUrlEnabled ? 'var(--color-yellow-700)' : 'var(--color-grey-600)',
						backgroundColor: customUrlEnabled ? 'var(--color-yellow-100)' : 'var(--color-grey-200)',
					}}
					transition={{
						duration: 0.1,
					}}
					className={ctl(`
                    cursor-pointer rounded-lg px-5 py-1 text-sm
                    whitespace-nowrap
                    relative transition-all
                    hover:translate-y-[-1px] active:translate-y-[2px]
                    `)}
					onClick={() => setCustomUrlEnabled(!customUrlEnabled)}
				>
					<span className="font-medium">
						{customUrlEnabled
							? t('reachOverride.linkOverrideEnabled')
							: t('reachOverride.linkOverrideDisabled')}
					</span>

					<p className="text-[10px] text-center opacity-70">
						<span>{t('reachOverride.advancedUseOnly')}</span>
					</p>
				</motion.button>

				<AnimateChangeInHeight>
					{customUrlEnabled && (
						<div className="pt-4 px-1 pb-1 flex flex-col gap-3">
							<TextField
								label={t('reachOverride.customUrl')}
								value={customUrl ?? ''}
								onChange={setCustomUrl}
							/>

							<p className="text-xs text-grey-700">
								{t('reachOverride.customUrlDescription')}
							</p>
							<p className="text-xs text-grey-700">
								{t('reachOverride.contactJobillan')}
							</p>
						</div>
					)}
				</AnimateChangeInHeight>
			</motion.div>
		</div>
	)
}
